import React, { useState ,useEffect} from "react";
import { playProcess, getJsonData ,updateBotData} from "../../Redux/actions/processes";
import "./index.css";

function PlayProcess(props) {  
    let { bot, offSet, getUpdateData} = props;

    const [workers, setWorkers] = useState(props.workers?props.workers.filter(obj => obj.worker_type === "standard"):[]);
    const [loading, setLoading] = useState(false);
    const [workerType, setWorkerType] = useState('standard');
    const [paramsType,setParamsType] = useState('String');
    const [worker, setWorker] = useState('default');
    const [excecutionType, setExcecutionType] = useState('0');
    let [params, setParams] = useState(false);
    const [errMsg,setErrMsg] = useState(false)
    const [jsonErrMsg,setJsonErrMsg] = useState(false)
    let [parameters, setParameters] = useState()
    let [arr,setArr] = useState()
    let [parametersData, setParametersData] = useState([{key:"", value:"", disabled : false,keyDisabled:false},
  ])
    
    useEffect(() => {
      const fetchData = async () => {
        let data=await getJsonData(props.bot.id,props.bot["TF_BOT_VERSION.version_number"])
        let values=data?Object.values(data):[]

        let object=[]
        values.map((item)=>{
          object.push({key:item.name,keyDisabled:true,value:item.value,disabled:false});
       })
       setArr(data)
       setParametersData(data?object:[{key:"", value:"", disabled : false,keyDisabled:false}])
      };
      fetchData();
    }, []);

    const handleSubmit = async (e) => {      
      e.preventDefault();
      let jsonvalues = arr?Object.values(arr):[];

      let obj={}
      jsonvalues.forEach((param) => {
        parametersData.forEach((item) => {
            if(param.name==item.key){
              param.value=item.value
            }
        })
      })
      let filtered = parametersData.filter((elem) => !jsonvalues.find(({ name }) => elem.key ===name) )
      filtered.forEach((item) => jsonvalues.push({"name":item.key,"value":item.value}))
      jsonvalues.map((param,ind) => {
        if(param.id){
          obj[param.id]=param
        }else {
          obj[ind] = param
        }
      })
      if(worker !== "default" && params){ 
        setLoading(true);   
        if(paramsType === 'JsonParameters'){
          let samplePayload={
            bot_id:bot.id,
            version_number:bot["TF_BOT_VERSION.version_number"],
            parameters:obj
          }
          // await updateBotData(samplePayload)
        }
        let payload = {
          bot_id : bot.id,
          worker_id : worker,
          params : paramsType === 'JsonParameters' ? JSON.stringify(obj):encodeURIComponent(parameters),       
          execution_type : excecutionType?excecutionType:"",
          channel : "web"
        }
        let status =  await playProcess(payload);
        setLoading(false);
        props.toggle();

        setTimeout(function(){
              if(status === 200){
                getUpdateData(offSet)
            }
        }, 4000);
    }
    else if(worker !== "default" && !params){
        setLoading(true);   
        let payload = {
            bot_id : bot.id,
            worker_id : worker,
            params : "",       
            execution_type : excecutionType?excecutionType:"",
            channel : "web"
        }
        let status = await playProcess(payload);
        setLoading(false);
        props.toggle();
        setTimeout(function(){            
            if(status === 200){
              getUpdateData(offSet)
            }
        }, 4000);
    }
    else{                    
       setErrMsg(true)
    }
  }
    const handleParameters = (e, index) => {
        let flowParams = parametersData.map((param, ind) => {
          if(index === ind){
             param[e.target.name] = e.target.value
             if(e.target.name === "key"){                 
              param["disabled"] = false
              if(e.target.value.length === 0){                  
                param["disabled"] = true
              }
             }
          }
          return param
        })
        setParametersData(flowParams);
      }
  
      const handleParams = (e, index) => {
          e.preventDefault()
        let flowParams = [...parametersData]
        if(index === (parametersData.length - 1 )){
          flowParams.push({key:"", value: "", disabled: true})
        }
        else{
          flowParams.splice(index, 1)
        }
        setParametersData(flowParams)
      }

      const handleParamsChange = (e, index) => {  
        if(e.target.type === 'radio'){
            setParamsType(e.target.name);
          }    
      }

      const isValidJson=(json)=> {
          try {
              JSON.parse(json);
              return true;
          } catch (e) {
              return false;
          }
      }

    const handleChange = (e) => {
        if(e.target.type === 'radio'){
            setWorkerType(e.target.name);
            if(e.target.name === "dynamic"){
                let _workers = props.workers? props.workers.filter(obj => obj.worker_type === "dynamic"):[];
                if(_workers.length > 0)
                    setWorkers([_workers[0]]);
                else
                    setWorkers([]);
            }
            else{
                let _workers = props.workers? props.workers.filter(obj => obj.worker_type === "standard"):[];
                if(_workers.length > 0)
                    setWorkers(_workers);
                else
                    setWorkers([]);
            }
        }
        else if(e.target.name === 'worker'){
            setWorker(e.target.value)
        }
    
        else if(e.target.name === "params"){
            setParams(!params)
        }
        else if(e.target.name === "excecutionType"){
            setExcecutionType(e.target.value)
        }
        else if(e.target.name === "parameters"){  
          setParameters(e.target.value)
          setJsonErrMsg(false)
        }
    }

    const focusOut = async(e) => {
        let check = isValidJson(e.target.value)
        if(check){
          setJsonErrMsg(false)
        }
        else{
          setJsonErrMsg(true)
        }
    };


    const renderParamsFields = () => {
        if(paramsType === 'String') {
            return(
                <div className="form-group " >
                    <input type="text" 
                    className="form-control"
                    name="parameters"
                    value={parameters} 
                    onChange={handleChange}/>
                </div>
            )
          } else if(paramsType === 'JsonParameters'){
              return(
                <div className="form-group " >
                {parametersData.map((param, ind) => {
                 return(
                  <div className="row mb-2" key={ind}>
                  <div className="col-5">
                    <input type="text" 
                           className="form-control"
                           name="key" key={ind} 
                           placeholder="key" 
                           value={param.key} 
                           disabled={param.keyDisabled}
                           onChange={(e) => handleParameters(e, ind)}/>
                  </div>
                  <div className="col-5">
                    <input type="text" 
                           className="form-control" 
                           name="value" key={ind} 
                           placeholder="value" 
                           value={param.value} 
                           onChange={(e) => handleParameters(e, ind)}/>
                  </div>
                  <div className="col-2">
                <button className="btn" 
                        style={{width:"100%"}} 
                        onClick={(e)=> handleParams(e, ind)} 
                        disabled={param.disabled}>{ind === parametersData.length- 1 || parametersData.length .length <= 1 ? "+" : "X"}</button>
                  </div>
                </div>)})}
              </div>
              )
          }
          
          else {
              return(
                <div>
                    <textarea className="form-control" name="parameters" value={parameters} style={{width:"100%"}} onBlur={focusOut} onChange={handleChange}></textarea>
                    {jsonErrMsg &&
                        <span className='error'>Please enter valid json object</span>}
                </div>
              )
          }
    }

    const renderParameters = () => {
        return(
          <div>
            <div className="form-group form-check form-check-inline">
                    <input className="form-check-input" 
                          type="radio" id="inlineCheckbox1"
                          name="String"
                          onChange={handleParamsChange}
                          checked={paramsType === 'String' ? true : false} />
                    <label className="form-check-label" htmlFor="inlineCheckbox1">String</label>
                </div>
                <div className="form-group form-check form-check-inline">
                    <input className="form-check-input" 
                          type="radio" id="inlineCheckbox2"
                          name="JSON"
                          onChange={handleParamsChange}
                          checked={paramsType === 'JSON' ? true : false} />
                    <label className="form-check-label" htmlFor="inlineCheckbox2">JSON</label>
                </div>
                <div className="form-group form-check form-check-inline">
                    <input className="form-check-input" 
                          type="radio" id="inlineCheckbox2"
                          name="JsonParameters"
                          onChange={handleParamsChange}
                          checked={paramsType === 'JsonParameters' ? true : false} />
                    <label className="form-check-label" htmlFor="inlineCheckbox2">Parameters</label>
                </div>

                {renderParamsFields()}
          </div>
        )
      }
    return (
        <div className="invite-users-container">
          <form>              
            { errMsg ? <div className="alert alert-danger" role="alert">
                Please fill all fields</div> :""
                }
            <div className="form-group form-check form-check-inline">
                <input className="form-check-input" 
                       type="radio" id="inlineCheckbox1"
                       name="standard"
                       onChange={handleChange}
                       checked={workerType === 'standard' ? true : false} />
                <label className="form-check-label" htmlFor="inlineCheckbox1">Reserved</label>
            </div>
            <div className="form-group form-check form-check-inline">
                <input className="form-check-input" 
                       type="radio" id="inlineCheckbox2"
                       name="dynamic"
                       onChange={handleChange}
                       checked={workerType === 'dynamic' ? true : false} />
                <label className="form-check-label" htmlFor="inlineCheckbox2">Dynamic</label>
            </div>
            <div className="form-group">
                <label htmlFor="worker">E-Worker Machines</label>
                <select className="form-control" id="worker" name="worker" value={worker} onChange={handleChange} required>
                    <option value="default">Please select an E-Worker Machine</option>
                    {workers.map((obj, index) => <option key={index} value={obj.worker_id}>{obj.queue_name}</option>)}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="excecution_type">Execution Options</label>
                <select className="form-control" name="excecutionType" value={excecutionType} onChange={handleChange} id="excecution_type" >
                    <option value="0" >Please select an execution option</option>
                    <option value="chrome">Chrome</option>
                    <option value="mozilla firefox">Mozilla Firefox</option>
                    <option value="microsoft edge">Microsoft Edge</option>
                    <option value="headless">Headless</option>
                </select>
            </div>
            <div style={{display:"flex", justifyContent:"space-between"}}>
                <label className="mt-2">Do you want to add any parameters?</label>
                <label className="switch">
                    <input type="checkbox" name="params" onChange={handleChange} checked={params} style={{marginLeft:"10px !important"}}/>
                    <span className="slider round" style={{left:"10px",right:"1px"}}>
                    </span>
                </label>
            </div>
            {params ? renderParameters() : null}
            <div className="roles-buttons text-center mt-4 mb-2">
                <button
                    style={{
                        color: "#02ce9d",
                        border: "solid 1px #02ce9d",
                        background: "none"
                    }}
                    onClick={() => props.toggle()}
                >
                    Cancel
                </button>
                <button
                    style={{
                        color: "#ffffff",
                        border: "#02ce9d",
                        background: "#02ce9d",
                        boxShadow: "0 6px 10px 0 rgba(2, 206, 157, 0.33)"
                    }}
                    onClick={handleSubmit}
                >
                    {loading ? <i style={{ color: "#ffffff" }} className="fas fa-circle-notch fa-spin"></i> : "Submit"}
                </button>
            </div>
            </form>
        </div>
    );
}

export default PlayProcess;
